import React from 'react';
import { CtaButton } from './CtaButton';
type SectionCtaProps = {
  label: string;
  sublabel?: string;
  id?: string;
};
export function SectionCta({
  label,
  sublabel,
  id
}: SectionCtaProps) {
  return <div className="mt-10 flex justify-center md:mt-12" data-id="element-56" data-mp="3ie88hcmibosm">
      <CtaButton label={label} sublabel={sublabel} id={id} data-id="element-57" data-mp="3ift2900zz3pf" />
    </div>;
}